if (!customElements.get('carousel-swiper')) {
  customElements.define(
    'carousel-swiper',
    class extends HTMLElement {
      connectedCallback() {
        if (typeof Swiper === 'undefined') {
          window.addEventListener('load', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }
      init() {
        if (this.swiper || typeof Swiper === 'undefined') return;
        const el = this.querySelector('.swiper');
        if (!el) return;
        // Swiper は自動再生OFFのときも params.autoplay を用意するため、ON/OFFは自前で覚える
        const autoplay = this.autoplayOptions();
        this.autoplayOn = autoplay !== false;
        this.swiper = new Swiper(el, {
          slidesPerView: 1,
          spaceBetween: this.gapSize(),
          speed: 400,
          simulateTouch: true,
          grabCursor: true,
          threshold: 5,
          resistanceRatio: 0.85,
          loop: this.dataset.loop === 'true',
          autoplay: autoplay,
          navigation: {
            prevEl: this.querySelector('.slider-button--prev'),
            nextEl: this.querySelector('.slider-button--next'),
          },
          pagination:
            this.dataset.pagination === 'true'
              ? { el: this.querySelector('.swiper-pagination'), clickable: true }
              : false,
        });
        this.bindModalPause();
        this.bindViewportAutoplay();
        this.initClamp();
      }
      gapSize() {
        const raw = this.dataset.spaceBetween;
        if (!raw) return 0;
        const n = parseFloat(raw);
        if (isNaN(n)) return 0;
        if (raw.trim().endsWith('rem')) return n * parseFloat(getComputedStyle(document.documentElement).fontSize);
        return n;
      }
      // 自動再生。矢印やスワイプで送ったあとも再生を続け、マウスを乗せている間は止まる。
      // 端末側で「視差効果を減らす」が有効なときは自動再生しない
      autoplayOptions() {
        if (this.dataset.autoplay !== 'true') return false;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
        const delay = parseFloat(this.dataset.autoplayDelay);
        return {
          delay: (isNaN(delay) ? 5 : delay) * 1000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }
      // 全文モーダルを開いている間は送らない（閉じたら再開）
      bindModalPause() {
        if (!this.autoplayOn) return;
        this.addEventListener('click', (event) => {
          if (!event.target.closest('modal-opener')) return;
          this.modalOpen = true;
          this.updateAutoplay();
        });
        this.handleModalClosed = () => {
          this.modalOpen = false;
          this.updateAutoplay();
        };
        document.body.addEventListener('modalClosed', this.handleModalClosed);
      }
      // 画面に入っている間だけ送る。裏のタブでも止める
      bindViewportAutoplay() {
        if (!this.autoplayOn) return;
        this.inView = false;
        this.swiper.autoplay.stop();
        this.observer = new IntersectionObserver((entries) => {
          this.inView = entries[0].isIntersecting;
          this.updateAutoplay();
        });
        this.observer.observe(this);
        this.handleVisibilityChange = () => this.updateAutoplay();
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
      }
      updateAutoplay() {
        if (!this.autoplayOn) return;
        if (this.inView && !document.hidden && !this.modalOpen) this.swiper.autoplay.start();
        else this.swiper.autoplay.stop();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        document.body.removeEventListener('modalClosed', this.handleModalClosed);
      }
      // 本文が指定行数を超えて切られているスライドにだけ「続きを読む」を出す。
      // 折りたたみ自体はCSS（縦積みの帯だけ）なので、PC幅では超過が出ず自動的に隠れる
      initClamp() {
        if (!this.classList.contains('clampOn')) return;
        const check = () => {
          this.querySelectorAll('.swiper-slide').forEach((slide) => {
            const body = slide.querySelector('.cbody');
            const opener = slide.querySelector('.cbodyMore');
            if (!body || !opener) return;
            opener.hidden = body.scrollHeight <= body.clientHeight + 1;
          });
        };
        check();
        // Webフォントの適用で行の折返しが変わるため再判定
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
        let timer;
        window.addEventListener('resize', () => {
          clearTimeout(timer);
          timer = setTimeout(check, 150);
        });
      }
    }
  );
}
